import React, { useState, useEffect, useRef } from 'react';

import intersectionObserverPresent from '../utils/intersectionObserverPresent';

const useObserver = (callback, options) => {
  const savedCallback = useRef();
  const observer = useRef();

  // Remember the latest callback.
  useEffect(
    () => {
      savedCallback.current = callback;
    },
    [callback]
  );

  // Set up the observer.
  useEffect(() => {
    if (intersectionObserverPresent) {
      const call = (entries, observer) => {
        savedCallback.current(entries, observer);
      };
      const newObserver = new IntersectionObserver(call, options);
      observer.current = newObserver;
      return () => newObserver.disconnect();
    }
  }, []);

  const attach = e => observer.current && observer.current.observe(e);

  const detach = e => observer.current && observer.current.unobserve(e);

  return [attach, detach];
};

export default useObserver;
